import { render, staticRenderFns } from "./NewsCoverUpload.vue?vue&type=template&id=127c7bd6&scoped=true"
import script from "./NewsCoverUpload.vue?vue&type=script&lang=js"
export * from "./NewsCoverUpload.vue?vue&type=script&lang=js"
import style0 from "./NewsCoverUpload.vue?vue&type=style&index=0&id=127c7bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c7bd6",
  null
  
)

export default component.exports